// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usuario-page {
    padding: 0;
    background: var(--bg-page);
    min-height: calc(100vh - 5.5rem);
}

.usuario-page .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 2rem;
}

/* Los estilos del header institucional ahora están en InstitutionalUI.css */

/* Contenido principal */
.usuario-page .main-content {
    padding: 0;
}

.usuario-page .content-card {
    background: var(--bg-card);
    border-radius: 12px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-color);
}

/* Los estilos de la toolbar institucional ahora están en InstitutionalUI.css */

.usuario-page .search-input {
    padding-left: 3rem;
    /* Increased to accommodate icon spacing */
    border-radius: 8px;
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    background-color: var(--bg-card);
    width: 280px;
    transition: all 0.3s ease;
}

.usuario-page .search-input:focus {
    border-color: var(--theme-primary);
    box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.15);
}

.usuario-page .search-icon {
    color: var(--theme-primary);
    /* Changed to theme color */
    left: 1rem;
    /* Push icon from the edge */
    z-index: 1;
    /* Ensure it stays on top */
}

.usuario-page .btn-export {
    background-color: var(--bg-card);
    color: var(--theme-primary);
    border: 1px solid var(--border-color);
    padding: 0.75rem;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.usuario-page .btn-export:hover {
    background-color: var(--theme-primary-soft);
    border-color: var(--theme-primary);
    transform: translateY(-2px);
}

/* Tabla */
.usuario-page .p-datatable {
    border: none;
    padding: 0.5rem 1.5rem 1.5rem 1.5rem;
    /* Added padding to sidebar/bottom */
}

.usuario-page .p-datatable .p-datatable-thead>tr>th {
    background: var(--bg-page);
    color: var(--text-primary);
    font-weight: 600;
    border-bottom: 2px solid var(--border-color);
}

.usuario-page .p-datatable .p-datatable-tbody>tr:hover {
    background: var(--theme-primary-soft);
}

/* Botones de acciones */
.usuario-page .action-buttons {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
}

.usuario-page .btn-edit {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    border: none;
    color: #ffffff !important;
    width: 36px;
    height: 36px;
    border-radius: 8px;
}

.usuario-page .btn-reset {
    background-color: var(--bg-card);
    border: 1px solid var(--theme-primary);
    color: var(--theme-primary) !important;
    width: 36px;
    height: 36px;
    border-radius: 8px;
}

.usuario-page .btn-delete {
    background: #dc3545 !important;
    border: none !important;
    color: #ffffff !important;
    width: 36px;
    height: 36px;
    border-radius: 8px;
}

.usuario-page .btn-delete .pi {
    color: #ffffff !important;
}

/* Diálogo */
.usuario-page .dialog-header {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    color: #ffffff;
    padding: 1.75rem 2rem;
    margin: -1.5rem -1.5rem 0 -1.5rem;
    border-radius: 12px 12px 0 0;
}

.usuario-page .dialog-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.usuario-page .dialog-header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.usuario-page .dialog-header-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
}

.usuario-page .dialog-header-icon i {
    font-size: 1.5rem;
}

.usuario-page .dialog-header h3 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 600;
}

.usuario-page .dialog-header p {
    margin: 0.25rem 0 0 0;
    opacity: 0.9;
    font-size: 0.9rem;
}

.usuario-page .btn-close-dialog {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: #ffffff;
    width: 36px;
    height: 36px;
    border-radius: 8px;
}

/* Formulario */
.usuario-page .dialog-form {
    padding: 2rem;
}

.usuario-page .form-label {
    color: var(--text-primary);
    font-weight: 600;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    display: block;
}

.usuario-page .form-label i {
    margin-right: 0.5rem;
    color: var(--theme-primary);
}

.usuario-page .form-input {
    border-radius: 8px;
    width: 100%;
}

.usuario-page .btn-search-reniec {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    color: #ffffff;
    border: none;
}

.usuario-page .input-group-end {
    border-radius: 0 8px 8px 0;
}

.usuario-page .form-error {
    color: #dc3545;
    font-size: 0.85rem;
    display: block;
    margin-top: 0.25rem;
}

/* Footer del diálogo */
.usuario-page .dialog-footer {
    padding: 1.25rem 2rem;
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    background: var(--bg-page);
    margin: 0 -1.5rem -1.5rem -1.5rem;
    border-radius: 0 0 12px 12px;
}

.usuario-page .btn-cancel {
    background-color: var(--bg-card);
    color: var(--text-secondary);
    border: 1px solid var(--border-color);
    padding: 0.65rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
}

.usuario-page .btn-save {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    color: #ffffff;
    border: none;
    padding: 0.65rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    box-shadow: 0 2px 8px var(--theme-primary-soft);
}

/* Responsive */
@media (max-width: 768px) {
    .usuario-page .page-header {
        padding: 1.5rem;
    }

    .usuario-page .page-header h1 {
        font-size: 1.4rem;
    }

    .usuario-page .main-content {
        padding: 1rem;
    }

    .usuario-page .toolbar {
        flex-direction: column;
        align-items: stretch;
    }

    .usuario-page .toolbar-actions {
        flex-direction: column;
        width: 100%;
    }

    .usuario-page .search-input {
        width: 100%;
    }

    .usuario-page .dialog-header h3 {
        font-size: 1.2rem;
    }

    .usuario-page .dialog-form {
        padding: 1.5rem;
    }
}

/* Targeted Styles for Dialog Refactor */
.user-dialog .p-dialog-header {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    color: #ffffff;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
    padding: 1.5rem;
}

.user-dialog .p-dialog-content {
    padding: 2rem !important;
    background: var(--bg-card);
}

.user-dialog .p-dialog-footer {
    padding: 1.5rem;
    background: var(--bg-page);
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    border-top: 1px solid var(--border-color);
}

.user-dialog .p-dialog-header-close-icon {
    color: #ffffff !important;
}

/* Los estilos del header de diálogo institucional ahora están en InstitutionalUI.css */

.dialog-content-specific {
    padding-top: 1rem;
}

.dialog-footer-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.btn-search-dni-specific {
    color: #ffffff;
    background-color: var(--theme-primary) !important;
    border-color: var(--theme-primary) !important;
}

.btn-save-dialog {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%) !important;
    color: #ffffff;
    border: none !important;
}

.btn-cancel-dialog {
    color: var(--text-secondary) !important;
    border-color: var(--border-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Usuario.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA,4EAA4E;;AAE5E,wBAAwB;AACxB;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA,+EAA+E;;AAE/E;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,UAAU;IACV,4BAA4B;IAC5B,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;AACzC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,4FAA4F;IAC5F,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI,4FAA4F;IAC5F,cAAc;IACd,qBAAqB;IACrB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,4FAA4F;IAC5F,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,qBAAqB;IACrB,yCAAyC;IACzC,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;IACrC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4FAA4F;IAC5F,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,wCAAwC;AACxC;IACI,4FAA4F;IAC5F,cAAc;IACd,6BAA6B;IAC7B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,+BAA+B;IAC/B,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uFAAuF;;AAEvF;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iDAAiD;IACjD,6CAA6C;AACjD;;AAEA;IACI,uGAAuG;IACvG,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,4CAA4C;AAChD","sourcesContent":[".usuario-page {\n    padding: 0;\n    background: var(--bg-page);\n    min-height: calc(100vh - 5.5rem);\n}\n\n.usuario-page .container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 2rem;\n}\n\n/* Los estilos del header institucional ahora están en InstitutionalUI.css */\n\n/* Contenido principal */\n.usuario-page .main-content {\n    padding: 0;\n}\n\n.usuario-page .content-card {\n    background: var(--bg-card);\n    border-radius: 12px;\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-color);\n}\n\n/* Los estilos de la toolbar institucional ahora están en InstitutionalUI.css */\n\n.usuario-page .search-input {\n    padding-left: 3rem;\n    /* Increased to accommodate icon spacing */\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n    width: 280px;\n    transition: all 0.3s ease;\n}\n\n.usuario-page .search-input:focus {\n    border-color: var(--theme-primary);\n    box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.15);\n}\n\n.usuario-page .search-icon {\n    color: var(--theme-primary);\n    /* Changed to theme color */\n    left: 1rem;\n    /* Push icon from the edge */\n    z-index: 1;\n    /* Ensure it stays on top */\n}\n\n.usuario-page .btn-export {\n    background-color: var(--bg-card);\n    color: var(--theme-primary);\n    border: 1px solid var(--border-color);\n    padding: 0.75rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.usuario-page .btn-export:hover {\n    background-color: var(--theme-primary-soft);\n    border-color: var(--theme-primary);\n    transform: translateY(-2px);\n}\n\n/* Tabla */\n.usuario-page .p-datatable {\n    border: none;\n    padding: 0.5rem 1.5rem 1.5rem 1.5rem;\n    /* Added padding to sidebar/bottom */\n}\n\n.usuario-page .p-datatable .p-datatable-thead>tr>th {\n    background: var(--bg-page);\n    color: var(--text-primary);\n    font-weight: 600;\n    border-bottom: 2px solid var(--border-color);\n}\n\n.usuario-page .p-datatable .p-datatable-tbody>tr:hover {\n    background: var(--theme-primary-soft);\n}\n\n/* Botones de acciones */\n.usuario-page .action-buttons {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: center;\n}\n\n.usuario-page .btn-edit {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    border: none;\n    color: #ffffff !important;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n}\n\n.usuario-page .btn-reset {\n    background-color: var(--bg-card);\n    border: 1px solid var(--theme-primary);\n    color: var(--theme-primary) !important;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n}\n\n.usuario-page .btn-delete {\n    background: #dc3545 !important;\n    border: none !important;\n    color: #ffffff !important;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n}\n\n.usuario-page .btn-delete .pi {\n    color: #ffffff !important;\n}\n\n/* Diálogo */\n.usuario-page .dialog-header {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    color: #ffffff;\n    padding: 1.75rem 2rem;\n    margin: -1.5rem -1.5rem 0 -1.5rem;\n    border-radius: 12px 12px 0 0;\n}\n\n.usuario-page .dialog-header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.usuario-page .dialog-header-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.usuario-page .dialog-header-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    backdrop-filter: blur(10px);\n}\n\n.usuario-page .dialog-header-icon i {\n    font-size: 1.5rem;\n}\n\n.usuario-page .dialog-header h3 {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 600;\n}\n\n.usuario-page .dialog-header p {\n    margin: 0.25rem 0 0 0;\n    opacity: 0.9;\n    font-size: 0.9rem;\n}\n\n.usuario-page .btn-close-dialog {\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: #ffffff;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n}\n\n/* Formulario */\n.usuario-page .dialog-form {\n    padding: 2rem;\n}\n\n.usuario-page .form-label {\n    color: var(--text-primary);\n    font-weight: 600;\n    font-size: 0.9rem;\n    margin-bottom: 0.5rem;\n    display: block;\n}\n\n.usuario-page .form-label i {\n    margin-right: 0.5rem;\n    color: var(--theme-primary);\n}\n\n.usuario-page .form-input {\n    border-radius: 8px;\n    width: 100%;\n}\n\n.usuario-page .btn-search-reniec {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    color: #ffffff;\n    border: none;\n}\n\n.usuario-page .input-group-end {\n    border-radius: 0 8px 8px 0;\n}\n\n.usuario-page .form-error {\n    color: #dc3545;\n    font-size: 0.85rem;\n    display: block;\n    margin-top: 0.25rem;\n}\n\n/* Footer del diálogo */\n.usuario-page .dialog-footer {\n    padding: 1.25rem 2rem;\n    border-top: 1px solid var(--border-color);\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    background: var(--bg-page);\n    margin: 0 -1.5rem -1.5rem -1.5rem;\n    border-radius: 0 0 12px 12px;\n}\n\n.usuario-page .btn-cancel {\n    background-color: var(--bg-card);\n    color: var(--text-secondary);\n    border: 1px solid var(--border-color);\n    padding: 0.65rem 1.5rem;\n    border-radius: 8px;\n    font-weight: 500;\n}\n\n.usuario-page .btn-save {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    color: #ffffff;\n    border: none;\n    padding: 0.65rem 1.5rem;\n    border-radius: 8px;\n    font-weight: 500;\n    box-shadow: 0 2px 8px var(--theme-primary-soft);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .usuario-page .page-header {\n        padding: 1.5rem;\n    }\n\n    .usuario-page .page-header h1 {\n        font-size: 1.4rem;\n    }\n\n    .usuario-page .main-content {\n        padding: 1rem;\n    }\n\n    .usuario-page .toolbar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .usuario-page .toolbar-actions {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .usuario-page .search-input {\n        width: 100%;\n    }\n\n    .usuario-page .dialog-header h3 {\n        font-size: 1.2rem;\n    }\n\n    .usuario-page .dialog-form {\n        padding: 1.5rem;\n    }\n}\n\n/* Targeted Styles for Dialog Refactor */\n.user-dialog .p-dialog-header {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    color: #ffffff;\n    border-top-right-radius: 12px;\n    border-top-left-radius: 12px;\n    padding: 1.5rem;\n}\n\n.user-dialog .p-dialog-content {\n    padding: 2rem !important;\n    background: var(--bg-card);\n}\n\n.user-dialog .p-dialog-footer {\n    padding: 1.5rem;\n    background: var(--bg-page);\n    border-bottom-right-radius: 12px;\n    border-bottom-left-radius: 12px;\n    border-top: 1px solid var(--border-color);\n}\n\n.user-dialog .p-dialog-header-close-icon {\n    color: #ffffff !important;\n}\n\n/* Los estilos del header de diálogo institucional ahora están en InstitutionalUI.css */\n\n.dialog-content-specific {\n    padding-top: 1rem;\n}\n\n.dialog-footer-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n}\n\n.btn-search-dni-specific {\n    color: #ffffff;\n    background-color: var(--theme-primary) !important;\n    border-color: var(--theme-primary) !important;\n}\n\n.btn-save-dialog {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%) !important;\n    color: #ffffff;\n    border: none !important;\n}\n\n.btn-cancel-dialog {\n    color: var(--text-secondary) !important;\n    border-color: var(--border-color) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
